module.exports = __webpack_public_path__ + "img/new_index_service_bg3.4129bd84.png";